import React from 'react';
import axios from 'axios';
import moment from 'moment';
import { Form, Divider, Icon } from 'semantic-ui-react';
import Students from './Students';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

const types = [
    { key: 1, value: 1, text: 'Svi studenti' },
    { key: 2, value: 2, text: 'Studenti po grupama' }
];

export default class ExamApplicationsPreviousYears extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            students: [],
            courses: [],
            course: '',
            exams: [],
            exam: '',
            groups: [],
            group: '',
            type: '',
            gradedActivityId: '',
            selectedData: [],
            academicYear: '',
            passedStudents:[],

            showGroups: false,
            loadedCourses: false,
            openStudents: false,

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.getCourses = this.getCourses.bind(this);
        this.getExams = this.getExams.bind(this);
        this.getStudents = this.getStudents.bind(this);
        this.getGroups = this.getGroups.bind(this);
        this.onDataChange = this.onDataChange.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.selectFilter = this.selectFilter.bind(this);
    }

    getGroups(courseImplementation) {
        let obj = {};
        axios.post(`course/groups/${courseImplementation}/${this.props.groupTypeId}`, { ...obj })
            .then(res => {
                let groups = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                this.setState({ groups });
            })
            .catch(err => {
                console.log('Failed to fetch groups');
            });
    }

    getCourses(academicYearId) {
        const params = { academicYearId };
        axios.get('/course/filter-implementations/', { params })
            .then(res => {
                const courses = res.data.map(el => ({
                    ...el,
                    key: el.id,
                    value: el.id,
                    icon: el.semesters[0].name._key === 'winter semester' ? <Icon name="snowflake" color="blue" /> : <Icon name="sun" color="yellow" />,
                    text: el.code !== null ? el.courseBasic.name + '  (' + el.code + ')' : el.courseBasic.name
                }));
                this.setState({ courses });
            })
            .catch(err => {
                console.log('Failed to fetch courses');
            });
    }

    getExams(course) {
        axios.get(`/exams/graded-activities/${this.state.academicYear}/${course}`)
            .then(res => {
                const exams = res.data.map(el => ({
                    ...el,
                    key: el.gradedActivityId,
                    value: el.gradedActivityId,
                    text: el.gradedActivityName + '  (' + moment(el.gradedActivityDate).format('D. M. YYYY.') + ')'
                })).filter(e=> e.finalized);
                this.setState({ exams });
            })
            .catch(err => {
                console.log('Failed to fetch exams');
            });
    }

    getStudents(courseImplGroupId) {
        const { marks } = this.props;
        let obj = { };
        axios({
            method: 'post',
            url: !courseImplGroupId ? `/exams/students/${this.state.exam}` : `/exams/students/${this.state.exam}/${courseImplGroupId}`,
            data: { ...obj }
        })
            .then(res => {
                const students = res.data.map(el => ({
                    ...el,
                    examDate: moment(el.date).format('D. M. YYYY.'),
                    inputDate: el.inputDate ? moment(el.inputDate).format('D. M. YYYY.') : '',
                    grade: marks.filter(ell => ell.id === el.markId)[0].displayName,
                    id: el.studentGradedActivityId
                }));
                this.setState({ students, openStudents: true });
            })
            .catch(err => {
                console.log('Failed to fetch students');
            });
    }

    onDataChange(row) {
        const pos = this.state.selectedData.findIndex(el => el.id === row.id);
        if (pos === -1) {
            this.setState({ selectedData: [...this.state.selectedData, row] });
        } else {
            const newSelectedData = this.state.selectedData.filter(el => el.id !== row.id);
            this.setState({ selectedData: newSelectedData });
        }
    }

    selectAll() {
        const { students, selectedData } = this.state;
        // deselect all if data.length === selectedData.length
        if (selectedData.length === students.length) {
            this.setState({ selectedData: [] });
        } else {
            this.setState({ selectedData: students });
        }
    }

    selectFilter() {
        const { students, selectedData } = this.state;

        let passedStudents = [];
        students.map(el =>
            (this.props.marks.find(e => e.id === el.markId).passed === true ?
                passedStudents.push(el)
                : null));

        this.setState({passedStudents})

        if (selectedData.length === passedStudents.length) {
            this.setState({ selectedData: [] });
        } else {
            this.setState({ selectedData: passedStudents });
        }
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
        if (name === 'academicYear') {
            this.setState({
                courses: [], course: '', exam: '', type: '', group: '', exams: [], openStudents: false, loadedCourses: false
            });
            this.getCourses(value);
        }
        if (name === 'course') {
            this.setState({
                exam: '', type: '', group: '', openStudents: false, loadedCourses: true
            });
            this.getExams(value);
        }

        if (name === 'type') {
            if (value === 1) { this.getStudents(null); }
            if (value === 2) { this.setState({ showGroups: true }); this.getGroups(this.state.course); }
        }
        if (name === 'group') {
            this.setState({ group: value });
            this.getStudents(value);
        }
    }

    render() {
        const { courses, exams } = this.state;
        return (
            <div>
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Akademska godina</label>
                            <Form.Dropdown clearable
                                placeholder="Odaberite akademsku godinu"
                                value={this.state.academicYear}
                                onChange={this.handleInputChange}
                                name="academicYear"
                                options={this.props.academicYears}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field disabled={!this.state.academicYear}>
                            <label>Predmet</label>
                            <Form.Dropdown clearable
                                placeholder="Odaberite predmet"
                                value={this.state.course}
                                onChange={this.handleInputChange}
                                name="course"
                                options={courses}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field disabled={!this.state.loadedCourses}>
                            <label>Ispit</label>
                            <Form.Dropdown clearable
                                placeholder="Odaberite ispit"
                                value={this.state.exam}
                                onChange={this.handleInputChange}
                                name="exam"
                                options={exams}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field disabled={!this.state.exam}>
                            <label>Svi studenti / po grupama</label>
                            <Form.Dropdown clearable
                                placeholder="Odaberite sve studente / po grupama"
                                value={this.state.type}
                                onChange={this.handleInputChange}
                                name="type"
                                options={types}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field disabled={!this.state.showGroups}>
                            <label>Grupe</label>
                            <Form.Dropdown clearable
                                placeholder="Odaberite grupu"
                                value={this.state.group}
                                onChange={this.handleInputChange}
                                name="group"
                                options={this.state.groups}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field />
                    </Form.Group>
                </Form>
                {this.state.openStudents &&
                <div><br />
                    <h3>Spisak studenata</h3>
                    <Divider />
                    <Students
                        students={this.state.students}
                        selectedData={this.state.selectedData}
                        onDataChange={this.onDataChange}
                        selectAll={this.selectAll}
                        selectFilter={this.selectFilter}
                        passedStudents={this.state.passedStudents}
                    /></div>}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamApplications/ExamApplicationsPreviousYears.js